import { render } from "./pagetwo.vue?vue&type=template&id=43ec89f7&scoped=true"
import script from "./pagetwo.vue?vue&type=script&lang=js"
export * from "./pagetwo.vue?vue&type=script&lang=js"

import "./pagetwo.vue?vue&type=style&index=0&id=43ec89f7&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43ec89f7"]])

export default __exports__